import { useEffect, useCallback } from "react";
import type { ScannerEvent } from "../types/scanner.ts";

/**
 * Subscribe to scan events from the ScannerBridge.
 *
 * In production: the Android shell drives `window.ScannerBridge.onScan`.
 * In dev: the keyboard simulator in `scanner-bridge.ts` fires the same events.
 *
 * The caller receives each scan via the `onScan` callback. The subscription is
 * automatically cleaned up when the component unmounts.
 */
export function useScanner(onScan: (event: ScannerEvent) => void): void {
  const stableOnScan = useCallback(onScan, [onScan]);

  useEffect(() => {
    if (!window.ScannerBridge) {
      console.warn("useScanner: window.ScannerBridge not available");
      return;
    }
    const unsubscribe = window.ScannerBridge.subscribe(stableOnScan);
    return unsubscribe;
  }, [stableOnScan]);
}
